"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getTagOrder_1 = __importDefault(require("../../models/getTagOrder"));
class TagCategory {
    constructor(item) {
        this.id = item.id;
        this.ledger_type = item.ledger_type;
        this.name = item.name;
        this.tags = item.tags.map(tag => ({ tag, order: (0, getTagOrder_1.default)(tag) }))
            .sort((a, b) => a.order - b.order)
            .map(it => it.tag);
    }
    get Tags() {
        return this.tags;
    }
    getTag(code) {
        return this.tags.filter(item => item.code === code).shift();
    }
}
exports.default = TagCategory;
